import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const beneficiaryData = (
    id?: string, 
    response?: any, 
    companies?: any, 
    types?: any, 
    userCompany?: any
): FormProps[] => {

    const safeCompanies = Array.isArray(companies) ? companies : [];
    const safeTypes = Array.isArray(types) ? types : [];

    const data: FormProps[] = [
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Nome do beneficiário*',
            value: id ? response?.name : null,
            rules: {
                required: 'O nome do beneficiário é obrigatório'
            },
            name: 'name',
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Tipo do beneficiário*',
            rules: {
                required: 'O tipo é obrigatório'
            },
            value: id ? response?.type : null,
            name: 'type',
            options: {
                placeholder: 'Tipo do beneficiário',
                data: safeTypes,
                value: id ? response?.type : null
            }
        }
    ];

    if(userCompany?.name?.toLowerCase() === 'causale') {
        data.push({
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Companhia*',
            rules: {
                required: 'Companhia é obrigatória'
            },
            value: id ? response?.companyId : null,
            name: 'companyId',
            options: {
                placeholder: 'Cliente',
                data: safeCompanies,
                value: id ? response?.companyId : null
            }
        })
    }

    return data;
};

export default beneficiaryData;